// CopyButton — kopierar text till klippbordet med visuell feedback
// (Copy → Copied!). Fallback vid clipboard-API-fel: markerar
// `[data-copy-target="<label>"]` så user kan trycka Ctrl/Cmd-C manuellt.
// Extraherad ur AiJsonDialog (#4 slice 2).

import { useCallback, useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { copyToClipboard } from '@/lib/clipboard';

export function CopyButton({ text, label = 'Copy' }: { text: string; label?: string }) {
  const [copied, setCopied] = useState(false);
  const handleCopy = useCallback(async () => {
    try {
      await copyToClipboard(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      const pre = document.querySelector(`[data-copy-target="${label}"]`) as HTMLElement;
      if (pre) {
        const range = document.createRange();
        range.selectNodeContents(pre);
        const sel = window.getSelection();
        sel?.removeAllRanges();
        sel?.addRange(range);
      }
    }
  }, [text, label]);

  return (
    <Button variant="outline" size="sm" onClick={handleCopy} className="gap-2">
      {copied ? (
        <><Check className="w-3.5 h-3.5 text-primary" /> Copied!</>
      ) : (
        <><Copy className="w-3.5 h-3.5" /> {label}</>
      )}
    </Button>
  );
}
